<div class="no-result-message" fxLayout="row" fxLayoutAlign="center center">
  <mat-icon>error_outline</mat-icon>
  <span class="message">{{ 'core.noResults' | translate }}</span>
</div>
